import { FaRegUser } from "react-icons/fa";
import formatNumberBr from "utils/regexPhoneBr";
import * as Styles from "./style";
import * as iconSVG from "../../../../assets/iconsSVG";

interface Props {
  data: any;
}

export function Especialistas(props: Readonly<Props>) {
  return (
    <Styles.Container>
      <Styles.Card>
        {props?.data?.supervisores[0]?.fotoBase64 ? (
          <img
            src={`data:image/png;base64,${props?.data?.supervisores[0]?.fotoBase64}`}
            alt="Foto corretor"
          />
        ) : (
          <Styles.IconHeader>
            <FaRegUser
              style={{ width: "30px", height: "30px", color: "#2d5bff" }}
            />
          </Styles.IconHeader>
        )}
        <div>
          <Styles.BodyCard>
            <Styles.Text>{props?.data?.supervisores[0]?.nome}</Styles.Text>
            {/* <Styles.Text> - </Styles.Text>
              <Styles.Subtitle>Supervisor</Styles.Subtitle> */}
            <a
              style={{
                textDecoration: "none",
                display: "flex",
                color: "#646363",
              }}
              target="_blank"
              href={`https://api.whatsapp.com/send?phone=${
                props?.data?.supervisores[0]?.celular ?? ""
              }`}
              rel="noreferrer"
            >
              <Styles.Row>
                <iconSVG.WhatsappIcon />
                <Styles.TextInfo>
                  {props?.data?.supervisores[0]?.celular
                    ? formatNumberBr(props?.data?.supervisores[0]?.celular)
                    : "--"}
                </Styles.TextInfo>
              </Styles.Row>
            </a>
            <a
              style={{
                textDecoration: "none",
                display: "flex",
                color: "#646363",
              }}
              href={`mailto:${props?.data?.supervisores[0]?.email ?? ""}`}
            >
              <Styles.Row>
                <iconSVG.EmailOutlookIcon color="#303030" size={22} />
                <Styles.TextInfo>
                  {props?.data?.supervisores[0]?.email ?? "--"}
                </Styles.TextInfo>
              </Styles.Row>
            </a>
          </Styles.BodyCard>
        </div>
      </Styles.Card>
    </Styles.Container>
  );
}
